import React from "react";
import {
  Box,
  Typography,
  ToggleButton,
  Button,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteRounded";

const ContentMenu = ({
  toggleDrawer,
  editItem,
  handleSave,
  headerItemData,
  handleApi,
  isMobile,
}) => {
  let headerType = isMobile ? "mobileTopbar" : "customTopbar";
  const [image, setImage] = React.useState(
    headerItemData.customHeader[headerType].links[editItem.index].content.image
  );

  const isClickable =
    headerItemData.customHeader[headerType].links[editItem.index].content
      .isClickAble;
  const isImageEnabled =
    headerItemData.customHeader[headerType].links[editItem.index].content
      .imageEnable;
  const isActive =
    headerItemData.customHeader[headerType].links[editItem.index].content
      .isActive;

  const handleContentForm = (key, value = "") => {
    if (key instanceof Object) {
      let name = key.target.name;
      value = key.target.value;
      handleSave("content", name, value);
      return;
    }
    handleSave("content", key, value);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file && isImageEnabled) {
      try {
        const base64String = await convertToBase64(file);
        setImage(base64String);
        handleSave("content", "image", base64String);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  const handleImageDelete = () => {
    if (isImageEnabled) {
      setImage(null);
      headerItemData.customHeader[headerType].links[
        editItem.index
      ].content.image = "";
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "5px",
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
          {`Header Item ${editItem.index + 1} - Contents`}
        </Typography>
        <Button
          variant="text"
          sx={{ fontWeight: "bold", color: "#fff" }}
          onClick={() => {
            toggleDrawer(true, editItem.index, "menu");
          }}
        >
          Back
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            padding: "0 10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            width: "100%",
          }}
        >
          <Box
            sx={{
              marginBottom: "12px",
              display: "flex",
              justifyContent: "space-between",
              columnGap: "5px",
            }}
          >
            <ToggleButton
              value={true}
              sx={{
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor: isClickable ? "#7f7d7d" : "",
                color: isClickable ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("isClickAble", true);
              }}
            >
              Clickable
            </ToggleButton>
            <ToggleButton
              value={false}
              sx={{
                marginLeft: "8px",
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor: !isClickable ? "#7f7d7d" : "",
                color: !isClickable ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("isClickAble", false);
              }}
            >
              Not Clickable
            </ToggleButton>
          </Box>

          <input
            type="text"
            placeholder="Enter Button Text"
            name="buttonText"
            disabled={!isClickable}
            value={
              headerItemData.customHeader[headerType].links[editItem.index]
                .content.buttonText
            }
            onChange={handleContentForm}
            style={{
              width: "100%",
              outline: "none",
              border: "1px solid #999",
              padding: "10px 5px",
              textAlign: "center",
              borderRadius: "5px",
              backgroundColor: "rgb(239 239 239)",
              marginBottom: "12px",
              fontWeight:
                headerItemData.customHeader[headerType].links[editItem.index]
                  .content.buttonTextType === "bold"
                  ? "bold"
                  : "normal",
              cursor: !isClickable ? "not-allowed" : "text",
              opacity: !isClickable ? 0.7 : 1,
            }}
          />

          <Box
            sx={{
              marginBottom: "12px",
              display: "flex",
              justifyContent: "space-between",
              columnGap: "5px",
            }}
          >
            <ToggleButton
              value="bold"
              sx={{
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .content.buttonTextType === "bold"
                    ? "#7f7d7d"
                    : "",
                color:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .content.buttonTextType === "bold"
                    ? "#fff"
                    : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("buttonTextType", "bold");
              }}
            >
              Button Text: Bold
            </ToggleButton>
            <ToggleButton
              value="regular"
              sx={{
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .content.buttonTextType === "regular"
                    ? "#7f7d7d"
                    : "",
                color:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .content.buttonTextType === "regular"
                    ? "#fff"
                    : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("buttonTextType", "regular");
              }}
            >
              Button Text: Regular
            </ToggleButton>
          </Box>

          <Box
            sx={{
              marginBottom: "12px",
              display: "flex",
              justifyContent: "space-between",
              columnGap: "5px",
            }}
          >
            <ToggleButton
              value={true}
              sx={{
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor: isImageEnabled ? "#7f7d7d" : "",
                color: isImageEnabled ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("imageEnable", true);
              }}
            >
              Image Enabled
            </ToggleButton>
            <ToggleButton
              value={false}
              sx={{
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor: !isImageEnabled ? "#7f7d7d" : "",
                color: !isImageEnabled ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("imageEnable", false);
              }}
            >
              Image Disabled
            </ToggleButton>
          </Box>

          <Box
            sx={{
              marginBottom: "12px",
              display: "flex",
              justifyContent: "space-between",
              columnGap: "5px",
            }}
          >
            <ToggleButton
              value={true}
              sx={{
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor: isActive ? "#7f7d7d" : "",
                color: isActive ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("isActive", true);
              }}
            >
              Active
            </ToggleButton>
            <ToggleButton
              value={false}
              sx={{
                flex: 1,
                fontSize: "11px",
                borderRadius: "50px",
                backgroundColor: !isActive ? "#7f7d7d" : "",
                color: !isActive ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleContentForm("isActive", false);
              }}
            >
              InActive
            </ToggleButton>
          </Box>

          {image ? (
            <Box sx={{ opacity: !isImageEnabled ? 0.7 : 1 }}>
              <img
                src={image}
                alt="uploaded"
                style={{
                  width: "75px",
                  height: "75px",
                  objectFit: "cover",
                  display: "block",
                  marginBottom: "8px",
                }}
              />
              <IconButton
                size="small"
                onClick={handleImageDelete}
                disabled={!isImageEnabled}
                sx={{
                  color: "red",
                  cursor: !isImageEnabled ? "not-allowed" : "pointer",
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ) : (
            <Button
              variant="outlined"
              component="label"
              disabled={!isImageEnabled}
              sx={{
                width: "fit-content",
                opacity: !isImageEnabled ? 0.7 : 1,
                cursor: !isImageEnabled ? "not-allowed" : "pointer",
              }}
            >
              Select Button Image
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
                disabled={!isImageEnabled}
              />
            </Button>
          )}
        </Box>
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{
            fontSize: "12px",
            padding: "6px",
            width: "90%",
            borderRadius: "50px",
            margin: "30px 0 20px 0",
          }}
          onClick={handleApi}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default ContentMenu;
